export default [
    {
        id: 1,
        value: {
            description: 'id_user_status',
            type: 'select',
            id: 1,
            // data: statusesToFilter,
            isIndexed: true,
            operator: 'equal',
            label: 'status'
        },
        label: 'Estado'
    }
];
